import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { MdSwapHoriz, MdWarningAmber } from "react-icons/md";
import { ROLE_LABELS } from "../../../../constants/oauth";
import { BtnLoader } from "../OAuthShell/OAuthShell";

// Scenario 3 -- a Carrier / warehouseUser / Admin session is active.
// There is deliberately no "continue to my dashboard" escape: the user must
// always end in a defined OAuth outcome.
const WrongAccountCard = ({
  clientName,
  user,
  role,
  switching,
  onSwitchAccount,
  onCancel,
}) => {
  const { t } = useTranslation("auth");
  const displayName =
    [user?.firstname, user?.lastname].filter(Boolean).join(" ") ||
    user?.username ||
    user?.email ||
    t("oauth.thisAccount");
  const initials = (displayName.match(/\b\w/g) || [])
    .slice(0, 2)
    .join("")
    .toUpperCase();
  const roleLabel = role
    ? t(`oauth.roles.${role}`, { defaultValue: ROLE_LABELS[role] || role })
    : t("oauth.thisAccountType");

  return (
    <div className="p-6 text-center">
      <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-state-warning-bg">
        <MdWarningAmber
          size={28}
          className="text-state-warning-text"
          aria-hidden="true"
        />
      </div>

      <h1 className="mb-2 text-[18px] font-bold text-ui-text">
        {t("oauth.wrongTitle", { client: clientName })}
      </h1>
      <p className="mb-4 text-[13px] leading-relaxed text-ui-text-muted">
        <Trans
          t={t}
          i18nKey="oauth.wrongBody"
          values={{ name: displayName, role: roleLabel, client: clientName }}
          components={{
            name: <span className="font-semibold text-ui-text" />,
            b: <span className="font-semibold text-ui-text" />,
          }}
        />
      </p>

      <div className="mb-4 flex items-center gap-2.5 rounded-lg bg-ui-surface-sunken px-3 py-2 text-left">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-light text-xs font-bold text-brand">
          {initials || "?"}
        </div>
        <div className="min-w-0">
          <p className="truncate text-[13px] font-semibold text-ui-text">
            {displayName}
          </p>
          {user?.email && (
            <p className="truncate text-[11px] text-ui-text-muted">
              {user.email}
            </p>
          )}
        </div>
      </div>

      <button
        type="button"
        onClick={onSwitchAccount}
        disabled={switching}
        className="flex h-11 w-full items-center justify-center gap-2 rounded-md bg-brand text-sm font-semibold text-white transition-colors hover:bg-brand-hover disabled:opacity-50"
      >
        {switching ? (
          <BtnLoader />
        ) : (
          <>
            <MdSwapHoriz size={18} aria-hidden="true" />
            {t("oauth.signInShipper")}
          </>
        )}
      </button>
      {/* The consequence is stated before the click, not after it. */}
      <p className="mt-2 text-[11px] text-ui-text-subtle">
        {t("oauth.signsYouOut")}
      </p>

      <button
        type="button"
        onClick={onCancel}
        disabled={switching}
        className="mt-3 h-11 w-full rounded-md border border-ui-border bg-ui-surface text-sm font-semibold text-ui-text transition-colors hover:bg-ui-surface-sunken disabled:opacity-50"
      >
        {t("oauth.cancelReturn", { client: clientName })}
      </button>
      <p className="mt-2 text-[11px] text-ui-text-subtle">
        {t("oauth.cancelTells", { client: clientName })}
      </p>
    </div>
  );
};

export default WrongAccountCard;
